import { fg } from '@atlaskit/platform-feature-flags/fg';
import {
	ExperienceName,
	PreviewCardRenderDiagnosticAttribute,
} from '@atlassian/conversation-assistant-instrumentation/constants/experience-tracker';
import type { ExperienceTrackerAPI } from '@atlassian/conversation-assistant-instrumentation/main';

export const abortPreviewCardRenderExperience = ({
	experienceTracker,
	reason,
	terminalReason,
	attributes = {},
}: {
	experienceTracker: ExperienceTrackerAPI;
	reason: string;
	terminalReason: 'awaiting-disambiguation' | 'user-cancelled';
	attributes?: Record<string, unknown>;
}): void => {
	if (!fg('aifc_preview_card_render_lifecycle_fix')) {
		return;
	}

	experienceTracker.abort({
		name: ExperienceName.PREVIEW_CARD_RENDER,
		reason,
		checkForTimeout: false,
		attributes: {
			...attributes,
			[PreviewCardRenderDiagnosticAttribute.TERMINAL_REASON]: terminalReason,
		},
	});
};
